import { EntityAdminHeaderLayoutProvider, type TabProps, type TabsState } from '@talos/kyoko';
import type { PropsWithChildren } from 'react';
import type { LayoutPanelApi } from '../../types';
import { BlotterPanel } from '../Trading/blotters/BlotterPanel';
import type { PanelBlottersState } from '../Trading/blotters/panelPersistence';

type EntityAdminPanelShellProps = PropsWithChildren<{
  panelApi: LayoutPanelApi;
  panelTabs: TabsState<TabProps> | undefined;
  panelBlottersState?: PanelBlottersState;
  'data-testid'?: string;
}>;

/**
 * Dockview host for EntityAdmin pages. Blotter/tabs state lives in panel params
 * (not global app-config blotters/tabs), so each panel is isolated from dealer
 * pages and from other panels; removing the panel drops that state with the layout.
 */
export function EntityAdminPanelShell({
  panelApi,
  panelTabs,
  panelBlottersState,
  children,
  'data-testid': dataTestId,
}: EntityAdminPanelShellProps) {
  return (
    <BlotterPanel
      panelApi={panelApi}
      panelTabs={panelTabs}
      panelBlottersState={panelBlottersState}
      data-testid={dataTestId}
      display="flex"
      flexDirection="column"
      overflow="hidden"
      minHeight={0}
    >
      <EntityAdminHeaderLayoutProvider>{children}</EntityAdminHeaderLayoutProvider>
    </BlotterPanel>
  );
}
